module.exports = __webpack_public_path__ + "img/calendar-blank-icon-orange.0f02faae.svg";